import React from "react";
import "../styles/ChecklistCard.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

export default function YTMultiRepCard() {
  return (
    <div className="checklist-card pb-5">
      <div className="checklist-card-header mb-5">
        This is Dual Representation
      </div>
      <p>
        You cannot proceed with the trade until ALL parties have given written
        consent to allow dual representation. This consent is obtained by
        completing the following document:
      </p>
      <br />
      <ul>
        <div key={Math.random()} className="pl-5 flex items-top">
          <FontAwesomeIcon
            icon={faCheck}
            size="lg"
            color="#00ad43"
            className="pr-1 pb-1"
          />
          <li>Agreement to Represent both Buyer & Seller</li>
        </div>
      </ul>
      <br />
      <p>
        If parties do not agree to dual representation, the designated
        representative must either:
      </p>
      <br />
      <ol>
        <li>Release one client</li>
        <li>Refer one of the parties to another agent</li>
        <li>The Buyer can choose to be a Customer</li>
      </ol>
      <br />
      <p>
        If ALL parties have given consent and you have signed the above form,
        you may proceed to the Checklist Documents. This should be a separate
        conversation and as such, these documents should be signed separately
        and not bundled with other deal documents.
      </p>
    </div>
  );
}
